import angular from 'angular';
import {
  bcpDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-test-document-dialog.controller';
import template from './edit-test-document-dialog.html';
import testDocumentNameMessagesTpl from './messages/test-document.name.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';


class dialogService {
  getOptions($event, { assessmentId, test, testDocument }) {
    return {
      controller,
      controllerAs: 'editTestDocumentDialogVM',
      locals: {
        assessmentId,
        test,
        testDocument
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editTestDocumentDialog', [
  alerts,
  bcpDataService,
  ngFileUpload,
  ssDialogService,
])
  .service('editTestDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('test-document.name.messages.html', testDocumentNameMessagesTpl);
  })
  .name;
